<template>
    <van-tabbar v-model="active" :safe-area-inset-bottom="true" :fixed="false" @change="handleChangeTabBar" active-color="#2990FF">
        <van-tabbar-item v-for="(item,key) in tabBarList" :key="key" >
            <template #icon="props">
                <i class="iconfont" :class="key == active ? item.activeIcon : item.icon"></i>
            </template>
            {{item.title}}
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "FooterTabBar",
    props: {
        tabBarList: {
            type: Array,
            default: [],
        },
        tabBarActive: {
            type: Number,
            default: 0,
        },
    },
    data () {
        return {
            active:0
        }
    },
    computed: {
        ...mapState(['tagList'])
    },
    created() {
       this.active = this.tabBarActive
    },
    methods:{
        handleChangeTabBar(index){
            let isPush = this.tagList.findIndex(find => find.name == this.tabBarList[index].routerName) < 0 ? true :false
            this.$router.push({
                name:this.tabBarList[index].routerName,
                params: {
                    isPush:isPush,
                },
            })
        },
    },
    watch: {
        '$route'(to) {
            const activeIndex = this.tabBarList.findIndex(item => item.routerName === to.name);
            this.active = activeIndex !== -1 ? activeIndex : 0;
        }
    }
}
</script>

<style scoped>

</style>
